import { createContext } from "react";

const TasksContext = createContext();

export default TasksContext;
